import { render, staticRenderFns } from "./Suc.vue?vue&type=template&id=f3cd97c8&scoped=true&"
import script from "./Suc.vue?vue&type=script&lang=js&"
export * from "./Suc.vue?vue&type=script&lang=js&"
import style0 from "./Suc.vue?vue&type=style&index=0&id=f3cd97c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3cd97c8",
  null
  
)

export default component.exports